"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HTMLProgressBar = void 0;
var React = require("react");
var styled_1 = require("../../styled");
var HTMLProgressBar = function (_a) {
    var value = _a.value, _b = _a.max, max = _b === void 0 ? 100 : _b, _c = _a.style, style = _c === void 0 ? {} : _c, height = _a.height, _d = _a.colors, colors = _d === void 0 ? {
        value: 'red',
        background: '#fee6e6',
    } : _d;
    var h = coerceHeightFromProps({ style: style, height: height });
    return (React.createElement(ProgressElement, { max: max, value: value, style: __assign(__assign({}, style), { height: h }), height: h, colors: colors }));
};
exports.HTMLProgressBar = HTMLProgressBar;
var coerceHeightFromProps = function (props) {
    var style = props.style || {};
    var height = props.height || style.height;
    if (typeof height === 'string') {
        height = Number(height.replace('px', ''));
    }
    if (!height || isNaN(height)) {
        var DEFAULT_HEIGHT = 12;
        height = DEFAULT_HEIGHT;
    }
    return height;
};
var getBorderRadius = function (props) {
    var height = coerceHeightFromProps(props);
    return height / 2 + 'px';
};
var getColor = function (which) { return function (props) { return props.colors[which]; }; };
var ProgressElement = styled_1.default.progress(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background: ", ";\n  border-radius: ", ";\n\n  &::-moz-progress-bar {\n    background: ", ";\n    border-radius: ", ";\n  }\n\n  &::-webkit-progress-value {\n    background: ", ";\n    border-radius: ", ";\n  }\n  &::-webkit-progress-bar {\n    background: ", ";\n    border-radius: ", ";\n  }\n"], ["\n  background: ", ";\n  border-radius: ", ";\n\n  &::-moz-progress-bar {\n    background: ", ";\n    border-radius: ", ";\n  }\n\n  &::-webkit-progress-value {\n    background: ", ";\n    border-radius: ", ";\n  }\n  &::-webkit-progress-bar {\n    background: ", ";\n    border-radius: ", ";\n  }\n"])), getColor('background'), getBorderRadius, getColor('value'), getBorderRadius, getColor('value'), getBorderRadius, getColor('background'), getBorderRadius);
var templateObject_1;
//# sourceMappingURL=index.js.map